import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQSection() {
  const faqs = [{
    question: '¿Cómo accedo?',
    answer: 'Recibes todo por correo inmediatamente después del pago'
  }, {
    question: '¿Funciona si él está distante?',
    answer: 'Sí. Incluye mensajes específicos para reactivar el interés'
  }, {
    question: '¿Tengo que ser experta en seducción?',
    answer: 'No. Está diseñado para que solo copies y uses'
  }, {
    question: '¿Funciona rápido?',
    answer: 'Muchas usuarias ven resultados desde el primer mensaje'
  }, {
    question: '¿Es pago único?',
    answer: 'Sí. Sin mensualidades'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="py-12 md:py-16 bg-[#1f1f35]" data-id="element-46">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10" data-id="element-48">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-49">
            Preguntas Frecuentes
          </h2>
          <div className="w-24 h-1 bg-rose-500 mx-auto rounded-full" data-id="element-50"></div>
        </motion.div>

        <div className="space-y-4" data-id="element-51">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="border border-white/10 rounded-xl overflow-hidden transition-all" data-id="element-52">
              <button onClick={() => toggleFAQ(index)} className="w-full flex justify-between items-center p-6 bg-white/5 text-left focus:outline-none focus:ring-2 focus:ring-rose-500/50" data-id="element-53">
                <span className="text-lg font-bold text-white" data-id="element-54">
                  {faq.question}
                </span>
                <ChevronDownIcon className={`w-6 h-6 text-rose-500 transform transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-55" />
              </button>

              <AnimatePresence data-id="element-56">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3,
              ease: 'easeInOut'
            }} className="overflow-hidden" data-id="element-57">
                    <div className="p-6 pt-0 bg-white/5 text-gray-300 font-medium border-t border-white/10" data-id="element-58">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}